import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { MdArrowDropDown } from 'react-icons/md'
import { RiDoorOpenLine } from 'react-icons/ri'
import { useHistory } from 'react-router-dom'
import { mainMenuTextsTranslate } from '../../i18n/translatedMessages'

import './dropdown.sass'

const DropdownMenu = () => {
    const history = useHistory()
    const dropdownRef = useRef(null)

    const [show, setShow] = useState(false)
    const [user, setUser] = useState({})

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem('user')))
    }, [])

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setShow(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [dropdownRef])

    const openDropdown = () => {
        setShow(!show)
    }

    const handleLogout = () => {
        localStorage.clear()
        history.push('/')
    }

    return (
        <div
            className="dropdown-main-menu"
            ref={dropdownRef}
            onClick={openDropdown}
        >
            {user?.name}
            <MdArrowDropDown size={20} />
            {show && (
                <div className="dropdown-user">
                    <ul>
                        <li>
                            <Link to='/candidate/edit-profile'>{mainMenuTextsTranslate.dropdownProfile}</Link>
                        </li>
                        <li onClick={handleLogout} >
                            {mainMenuTextsTranslate.dropdownLogout}
                        </li>
                    </ul>
                </div>
            )}
        </div>
    )
}
export default DropdownMenu
